<ng-container *ngIf="{ ois: optInSettings$ | async } as obs">

  <header>
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand ms-4" href="#">{{obs.ois?.orgName}}</a>
    </nav>
  </header>


  <div class="container">

    <div class="policy" *ngIf="{ ois: optInSettings$ | async } as obs">

      <h2 id="-org-name-sms-terms-of-service">{{obs.ois?.orgName}} SMS Terms of Service</h2>
      <p><em>Powered by Parlance LLC – Effective May 23 2025</em></p>
      <h3 id="1-program-description">1. Program Description</h3>
      <p>When you opt in, you will receive text messages from <strong>{{obs.ois?.orgName}}</strong> about fund-raising campaigns, event invitations, thank-you notes, pledge reminders, admissions information, donor updates, and other advancement-related news. Message frequency varies; recurring messages may be sent.</p>
      <h3 id="2-cost">2. Cost</h3>
      <p>Message &amp; data rates may apply for all texts sent to or from us. Contact your wireless carrier for plan details.</p>
      <h3 id="3-opt-out">3. Opt-Out</h3>
      <p><strong>Reply <code>STOP</code> to any {{obs.ois?.orgName}} text to cancel.</strong>
        After we receive <code>STOP</code>, we’ll send one confirmation text and you will no longer receive messages unless you opt in again.</p>
      <h3 id="4-help">4. Help</h3>
      <p>Need help? Reply <code>HELP</code> to any message or email <strong><a href="mailto:support@parlance.app">support@parlance.app</a></strong>.</p>
      <h3 id="5-carrier-disclaimer">5. Carrier Disclaimer</h3>
      <p>Wireless carriers are <strong>not</strong> liable for delayed or undelivered messages.</p>
      <h3 id="6-privacy">6. Privacy</h3>
      <p>No mobile information (opt-in data, consent, or phone numbers) will be shared or sold to third parties or affiliates for marketing purposes. See our full Privacy Policy at <strong><a [routerLink]="['/', 'optin', orgId, 'privacy']">https://parlance.app/optin/{{orgId}}/privacy</a></strong>.</p>
      <h3 id="7-eligibility-responsibility">7. Eligibility &amp; Responsibility</h3>
      <p>The program is for U.S. residents 18 years or older. By opting in, you confirm you are the mobile account holder (or have their permission) and you accept these Terms.</p>
      <h3 id="8-changes">8. Changes</h3>
      <p>We may update these Terms or discontinue the program at any time. Continued participation after changes means you accept the revised Terms.</p>
      <h3 id="9-contact">9. Contact</h3>
      <p>Parlance LLC
        830 Glenwood Ave SE, Suite 510-408
        Atlanta, GA 30316
        Email: <strong><a href="mailto:support@parlance.app">support@parlance.app</a></strong>
      </p>

    </div>
  </div>

</ng-container>
